import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { comfortTrue } from "./comfortTrueAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    UsedQuestionsId:[],
    Attributes: [],
    LastCard: false,
}

export const comfortTrueAsync = createAsyncThunk(
    "/comforttrue",
    async ({gender, player},{getState, rejectWithValue }) => {
        try {
            const state = getState();
            const usedid = state.comfortTrue.UsedQuestionsId
            const sessionid = state.gameStatus.sessions['comfort'].sessionId


            const response = await comfortTrue(gender, player, usedid, sessionid);
            return response
        } catch (error) {
            console.error("Error in comfortTrueAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
)

export const comfortTrueSlice = createSlice({
    name: "comforttrue",
    initialState,
    reducers: {
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.Attributes = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(comfortTrueAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(comfortTrueAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectComfortTrue = (state) => state.comfortTrue
export const {resetState} = comfortTrueSlice.actions;

export default comfortTrueSlice.reducer